import { ActiveDatepicker } from 'component/Search/Datepicker/types';
import { CrossValidationError } from 'component/Search/Form/__hooks/useCrossDateValidation';

import { atom } from 'jotai';

export const durationLayerVisibilityAtom = atom(false);
export const activeDatepickerAtom = atom(ActiveDatepicker.Return);
export const crossValidationErrorAtom = atom(CrossValidationError.NoError);
export const refreshNoteVisibility = atom(false);
export const fallbackNoteVisibility = atom(false);
export const filterChanged = atom(false);
export const filterReset = atom(false);
